var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7633 10.31C13.804 7.42841 13.1215 3.43824 10.2399 1.39806C7.3583 -0.642115 3.36813 0.0398943 1.32795 2.92198C-0.712229 5.80358 -0.0302199 9.79326 2.85187 11.8334C4.90862 13.2896 7.62789 13.4017 9.79725 12.1206L14.5109 16.8059C15.0198 17.3417 15.8666 17.3631 16.4024 16.8542C16.9381 16.3457 16.9596 15.4989 16.4511 14.9632C16.435 14.9461 16.4194 14.9305 16.4024 14.9144L11.7633 10.31ZM6.54174 10.7468C4.26464 10.7473 2.41848 8.90261 2.41702 6.6255C2.41653 4.3484 4.26122 2.50225 6.53882 2.50127C8.81299 2.5003 10.6582 4.34206 10.6626 6.61624C10.6665 8.89383 8.82274 10.7429 6.54466 10.7468C6.54369 10.7468 6.5432 10.7468 6.54174 10.7468Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bb1beebce734bed7482fba48601970e6.svg";
export { ForwardRef as ReactComponent };